module.exports = __webpack_public_path__ + "img/SmaraView.b70bb578.png";